﻿

(function () {
    var g2;
    $(document).ready(function () {
        var chartDiv = document.getElementById("lm__chart-dygraphs");
        var labelDiv = document.getElementById("lm__chart-status");
        if (window.Dygraph && chartDiv && labelDiv) {
            g2 = new Dygraph(
                document.getElementById("lm__chart-dygraphs"),
                chartDiv.dataset.rowdata,
                {
                    labelsDiv: document.getElementById("lm__chart-status"),
                    labelsKMB: false,
                    colors: [
                        "#006927",
                        "#F59C00",
                        "#76B843",
                        "#F54A00",
                        "#565656"],
                    width: "100%",
                    height: 540,
                    title: chartDiv.dataset.title,
                    axisLineColor: "white",
                    ylabel: "kr/ton"
                }
            );
        }

        //*** Chosed Selected Period in dropdown ***
        var selectMonthElement = document.getElementById("selectMonthPeriod");
        if (selectMonthElement) {
            $("#selectMonthPeriod > li > ul > li > a").click(function () {
                var dataValueType = $(this).parent().attr("data-value");
                var currentPageId = $("#CurrentPageId").val();
                var selected = [];
                $("input[name=type]:checked").each(function () {
                    selected.push($(this).attr("id"));
                });

                $.ajax({
                    type: "POST",
                    url: "/api/pricegraph/filter",
                    cache: false,
                    data: { idArray: selected, pageId: currentPageId, selectedPeriod: dataValueType },
                    success: function (data) {
                        if (data.length !== 0) {
                            if (data.ModelString.length !== 0 && data.ColorCodes.length !== 0) {
                                $("#pricegraphdiv").html(data.ModelString);

                                var input = document.createElement("input");
                                input.setAttribute("type", "hidden");
                                input.setAttribute("name", "SelectedPeriod");
                                input.setAttribute("value", dataValueType);
                                input.setAttribute("id", "SelectedPeriod");

                                $("#selectedperioddiv").html(input);

                                var chartDiv = document.getElementById("lm__chart-dygraphs");
                                var labelDiv = document.getElementById("lm__chart-status");
                                if (window.Dygraph && chartDiv && labelDiv) {
                                    g2 = new Dygraph(
                                        document.getElementById("lm__chart-dygraphs"),
                                        chartDiv.dataset.rowdata,
                                        {
                                            labelsDiv: document.getElementById("lm__chart-status"),
                                            labelsKMB: false,
                                            colors: data.ColorCodes,
                                            width: "100%",
                                            height: 540,
                                            title: chartDiv.dataset.title,
                                            axisLineColor: "white",
                                            ylabel: "kr/ton"
                                        }
                                    );
                                }
                            }
                            else {
                                // Show empty graph
                                g2 = new Dygraph(
                                    document.getElementById("lm__chart-dygraphs"), "X\n",
                                    {
                                        labelsDiv: document.getElementById('lm__chart-status'),
                                        labelsKMB: false,
                                        width: "100%",
                                        height: 540,
                                        title: document.getElementById("lm__chart-dygraphs").dataset.title,
                                        axisLineColor: "white"
                                    }
                                );
                            }
                        }
                    },
                    error: function (e) {
                        console.log("Something went wrong with the AJAX request!");
                        console.log(e.responseText);
                    }
                });
            });
        }

        //*** Filtered from checkboxes ***
        $(document).on("change", ".pricegraph-checkbox input", function () {
            var selected = [];
            var currentPageId = $("#CurrentPageId").val();
            var selectedPeriod = $("#SelectedPeriod").val();

            $("input[name=type]:checked").each(function () {
                selected.push($(this).attr("id"));
            });

            $.ajax({
                type: "POST",
                url: "/api/pricegraph/filter",
                cache: false,
                data: { idArray: selected, pageId: currentPageId, selectedPeriod: selectedPeriod },
                success: function (data) {
                    if (data.length !== 0) {
                        if (data.ModelString.length !== 0 && data.ColorCodes.length !== 0) {
                            $("#pricegraphdiv").html(data.ModelString);
                            var chartDiv = document.getElementById("lm__chart-dygraphs");
                            var labelDiv = document.getElementById("lm__chart-status");
                            if (window.Dygraph && chartDiv && labelDiv) {
                                g2 = new Dygraph(
                                    document.getElementById("lm__chart-dygraphs"),
                                    chartDiv.dataset.rowdata,
                                    {
                                        labelsDiv: document.getElementById("lm__chart-status"),
                                        labelsKMB: false,
                                        colors: data.ColorCodes,
                                        width: "100%",
                                        height: 540,
                                        title: chartDiv.dataset.title,
                                        axisLineColor: "white",
                                        ylabel: "kr/ton"
                                    }
                                );
                            }
                        }
                        else {
                            // Show empty graph
                            g2 = new Dygraph(
                                document.getElementById("lm__chart-dygraphs"), "X\n",
                                {
                                    labelsDiv: document.getElementById('lm__chart-status'),
                                    labelsKMB: false,
                                    width: "100%",
                                    height: 540,
                                    title: document.getElementById("lm__chart-dygraphs").dataset.title,
                                    axisLineColor: "white",
                                    ylabel: "kr/ton"
                                }
                            );
                        }
                    }
                },
                error: function (e) {
                    console.log("Something went wrong with the AJAX request!");
                    console.log(e.responseText);
                }
            });
        });
    });
})();
